module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-bbin-slot.b1912f75.png";